import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { School } from "lucide-react";

export default function EducationClasses() {
  return (
    <SectorCRUDTable
      endpoint="/chef/education/classes"
      eyebrow="Éducation · Classes"
      title="Classes & groupes"
      sub="Organisez vos élèves en classes ou groupes pédagogiques."
      testidPrefix="classe"
      allowEdit
      defaultRow={() => ({ nom: "", niveau: "", annee_scolaire: `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`, professeur_principal: "", notes: "" })}
      columns={[
        { key: "nom", label: "Classe" },
        { key: "niveau", label: "Niveau", width: "120px" },
        { key: "annee_scolaire", label: "Année", width: "140px", render: (v) => <span className="font-mono">{v}</span> },
        { key: "nb_eleves", label: "Élèves", width: "80px", render: (v) => <span className="font-bold">{v || 0}</span> },
        { key: "professeur_principal", label: "Prof. principal" },
      ]}
      fields={[
        { key: "nom", label: "Nom de la classe", span: 6, required: true, placeholder: "6ème A" },
        { key: "niveau", label: "Niveau", span: 6, placeholder: "6ème, CM2, BTS 1…" },
        { key: "annee_scolaire", label: "Année scolaire", span: 6, required: true, placeholder: "2025-2026" },
        { key: "professeur_principal", label: "Professeur principal", span: 6 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={School}
      emptyText="Aucune classe. Cliquez sur Ajouter."
    />
  );
}
